import React from "react";

export default function Card({ title, children, right }) {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 sm:p-5 md:p-6">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-3 md:mb-4">
        <h2 className="text-base md:text-lg font-semibold text-gray-800">{title}</h2>
        {right}
      </div>
      {children}
    </div>
  );
}
